import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TitileNavbarComponent } from '../navbar';
import { PageLayoutComponent } from '../page-layout/page-layout.component';

@Component({
  selector: 'lib-policy-privacy-content',
  templateUrl: './policy-privacy-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, PageLayoutComponent]
})
export class PolicyPrivacyContentComponent {}
